import { render, staticRenderFns } from "./objectDataChangeTab.vue?vue&type=template&id=5a284582&scoped=true&"
import script from "./objectDataChangeTab.vue?vue&type=script&lang=js&"
export * from "./objectDataChangeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a284582",
  null
  
)

export default component.exports